<div class="page-content bg-grey" style="height: 100%">
    <p-panel header="Customers">
        <ng-template #icons>
            <p-buttongroup>
                <p-button
                    size="small"
                    [severity]="layout === 'list' ? 'primary' : 'contrast'"
                    (click)="layout = 'list'"
                    (keyup.enter)="layout = 'list'"
                    icon="pi pi-bars"
                />
                <p-button
                    size="small"
                    [severity]="layout === 'grid' ? 'primary' : 'contrast'"
                    (click)="layout = 'grid'"
                    (keyup.enter)="layout = 'grid'"
                    icon="pi pi-table"
                />

                <p-button size="small" (click)="onRefresh()" (keyup.enter)="onRefresh()" icon="pi pi-refresh" />
                <p-button size="small" (click)="onNew()" (keyup.enter)="onNew()" severity="primary" label="Add new" />
            </p-buttongroup>
        </ng-template>

        @if (showLoading) {
            <div style="text-align: center">
                <p-progressSpinner
                    styleClass="w-4rem h-4rem"
                    strokeWidth="4"
                    animationDuration="1.5s"
                ></p-progressSpinner>
                <div class="mt-2 mb-2">
                    {{ loadingStr }}
                </div>
            </div>
        }

        <div [style.display]="!showLoading ? 'block' : 'none'">
            <p-dataview #dv [value]="items" [layout]="layout">
                <ng-template #list let-items>
                    <div class="list">
                        @for (customer of items; track customer.uuid) {
                            <div class="list-line">
                                <p-menu #menu [popup]="true" appendTo="body" [model]="contextMenu" />

                                <div
                                    tabindex="0"
                                    role="button"
                                    (click)="onCustomerSelected(customer)"
                                    (keydown.enter)="onCustomerSelected(customer)"
                                    (keydown.space)="$event.preventDefault(); onCustomerSelected(customer)"
                                    style="width: 9rem; height: 5rem"
                                    class="customer-logo-base"
                                    [style.backgroundImage]="'url(images/default_customer_image.png)'"
                                ></div>
                                <div class="maximize-flex">
                                    <h5 class="card-title">
                                        {{ customer.name }}
                                        <p-button
                                            size="small"
                                            [ngStyle]="{'margin-left': '0.25rem'}"
                                            severity="contrast"
                                            (click)="onContextMenuSelect(customer); menu.toggle($event)"
                                            (keyup.enter)="onContextMenuSelect(customer); menu.toggle($event)"
                                            icon="pi pi-ellipsis-h"
                                        />
                                    </h5>

                                    <p class="card-text fw-bold mb-4">
                                        {{ desc.length > 100 ? (desc | slice: 0 : 100) + '...' : desc }}<br />
                                    </p>
                                </div>
                                <div class="p-fluid">
                                    <p-button
                                        size="small"
                                        icon="pi pi-external-link"
                                        [ngStyle]="{width: '100%'}"
                                        [fluid]="true"
                                        (click)="onCustomerSelected(customer)"
                                        (keyup.enter)="onCustomerSelected(customer)"
                                    />
                                </div>
                            </div>
                        }
                    </div>
                </ng-template>

                <ng-template #grid let-items>
                    <div class="grid">
                        @for (customer of items; track customer.uuid) {
                            <div class="card">
                                <p-menu #menu [popup]="true" appendTo="body" [model]="contextMenu" />

                                <div
                                    tabindex="0"
                                    role="button"
                                    (click)="onCustomerSelected(customer)"
                                    (keydown.enter)="onCustomerSelected(customer)"
                                    (keydown.space)="$event.preventDefault(); onCustomerSelected(customer)"
                                    style="width: 100%; height: 10rem"
                                    class="customer-logo-base"
                                    [style.backgroundImage]="'url(images/default_customer_image.png)'"
                                ></div>

                                <div class="card-body">
                                    <h5 class="card-title hcol-flex">
                                        <div class="hcol-grow title">
                                            {{ customer.name }}
                                        </div>
                                        <div>
                                            <p-button
                                                size="small"
                                                [ngStyle]="{'margin-left': '0.25rem'}"
                                                severity="contrast"
                                                (click)="onContextMenuSelect(customer); menu.toggle($event)"
                                                (keyup.enter)="onContextMenuSelect(customer); menu.toggle($event)"
                                                icon="pi pi-ellipsis-h"
                                            />
                                        </div>
                                    </h5>
                                    <p class="card-text fw-bold mb-4">
                                        {{ desc.length > 100 ? (desc | slice: 0 : 100) + '...' : desc }}
                                    </p>
                                    <div class="p-fluid">
                                        <p-button
                                            size="small"
                                            label="Select"
                                            icon="pi pi-external-link"
                                            [ngStyle]="{width: '100%'}"
                                            [fluid]="true"
                                            (click)="onCustomerSelected(customer)"
                                            (keyup.enter)="onCustomerSelected(customer)"
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </ng-template>
            </p-dataview>
        </div>
    </p-panel>
</div>
